import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  addNBHoliday,
  editNonBusiness,
  deleteNBHoliday,
  getNBHoliday,
  setNBHolidayList,
} from '../../features/setting/settingSlice'
// Datepick
import ja from 'date-fns/locale/ja'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { toast } from 'react-toastify'
import SpinnerComp from '../util/SpinnerComp'
import ReactPaginate from 'react-paginate'
import {
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaPlusCircle,
  FaTimes,
} from 'react-icons/fa'
import { setToken } from '../../features/auth/authSlice'
import CalendarIcon from '../../assets/calendar-icon.svg'
import Modal from 'react-modal'

const NonBusinessHoliday = () => {
  const { token } = useSelector((state) => state.auth)
  const { holidayLoading, nb_holiday, nb_holiday_list } = useSelector(
    (state) => state.setting,
  )
  const holidayDate = nb_holiday?.value

  const dispatch = useDispatch()
  useEffect(() => {
    if (token) {
      dispatch(getNBHoliday(token))
        .unwrap()
        .then(({ res, newToken }) => {
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        })
        .catch((error) => {})
    }
    // eslint-disable-next-line
  }, [])

  // Add Holidays
  const [holidayStartDate, setHolidayStartDate] = useState(new Date())
  const [holidayEndDate, setHolidayEndDate] = useState(new Date())
  const submitHolidayDate = (e) => {
    e.preventDefault()
    const holidayStartDateSet = moment(holidayStartDate).format('YYYY/MM/DD')
    const holidayEndDateSet = moment(holidayEndDate).format('YYYY/MM/DD')
    const data = {
      start_date: holidayStartDateSet,
      end_date: holidayEndDateSet,
    }

    dispatch(addNBHoliday({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res.data && res.data.result === 'success') {
          dispatch(getNBHoliday(token))
          setHolidayStartDate(new Date())
          setHolidayEndDate(new Date())
          toast.success('休日が追加されました')
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {})
  }

  // Delete Holidayss
  // Delete Holidayss
  const [isModalDelete, setIsModalDelete] = useState(false)
  const [deleteTarget, setDeleteTarget] = useState(null)
  const onDeleteClick = (holi) => {
    setIsModalDelete(true)
    setDeleteTarget(holi)
  }
  const onDeleteSubmit = (e) => {
    e.preventDefault()
    const data = {
      id: deleteTarget.id,
    }
    dispatch(deleteNBHoliday({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === 'success') {
          dispatch(getNBHoliday(token))
          toast.success('長期休暇が削除されました。')
        }
      })
      .catch((error) => {})
    setIsModalDelete(false)
  }

  // Edit Holidayss
  const [isModalEdit, setIsModalEdit] = useState(false)
  const [editTarget, setEditTarget] = useState(null)
  const [holidayStartDateEdit, setHolidayStartDateEdit] = useState(new Date())
  const [holidayEndDateEdit, setHolidayEndDateEdit] = useState(new Date())
  // const [showMessageEdit, setShowMessageEdit] = useState(false)
  const onEditClick = (holi) => {
    setIsModalEdit(true)
    setEditTarget(holi)
  }
  useEffect(() => {
    if (editTarget) {
      setHolidayStartDateEdit(
        moment(editTarget?.start_date, 'YYYY/MM/DD').toDate(),
      )
      setHolidayEndDateEdit(moment(editTarget?.end_date, 'YYYY/MM/DD').toDate())
      // setShowMessageEdit(editTarget?.message_flag === 1 ? true : false)
    }
  }, [editTarget])

  const onEditSubmit = (e) => {
    e.preventDefault()
    const data = {
      id: editTarget.id,
      start_date: moment(holidayStartDateEdit).format('YYYY/MM/DD'),
      end_date: moment(holidayEndDateEdit).format('YYYY/MM/DD'),
      // message_flag: showMessageEdit === true ? 1 : 0,
    }
    // console.log(data)
    dispatch(editNonBusiness({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === 'success') {
          dispatch(getNBHoliday(token))
          toast.success('長期休暇が更新されました')
        }
      })
      .catch((error) => {})
    setIsModalEdit(false)
    setHolidayStartDate(new Date())
    setHolidayEndDateEdit(new Date())
  }

  // Pagination
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0)
  const [itemsPerPage, setItemsPerPage] = useState(30)
  // Set start and end
  const endOffset = itemOffset + itemsPerPage
  const currentItems = nb_holiday?.value?.slice(itemOffset, endOffset)
  const pageCount = Math.ceil(nb_holiday?.value?.length / itemsPerPage)

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % nb_holiday?.value?.length
    // console.log(`Loading items from ${itemOffset} to ${endOffset}`)
    setItemOffset(newOffset)
  }

  return (
    <div className="mt-12">
      {/* Holiday Date Pick */}
      <div className="flex justify-between px-2 items-end py-2">
        <div className="flex flex-col">
          <h1 className="font-semibold py-2">非営業日設定 :</h1>
          <form
            onSubmit={submitHolidayDate}
            className="w-12/12 flex flex-col sm:flex-row justify-start sm:items-end gap-2"
          >
            {/* Start Date */}
            <div className="w-full sm:w-3/12 flex flex-col gap-2">
              <p>非営業開始日</p>

              <div className="w-full flex justify-between items-center gap-2 bg-gray-200 p-2 rounded-[8px] border border-gray-500">
                <img src={CalendarIcon} alt="calendar-icon" className="w-5" />

                <DatePicker
                  selected={holidayStartDate}
                  onChange={(date) => setHolidayStartDate(date)}
                  dateFormat="yyyy/MM/dd"
                  locale={ja}
                  className="w-full outline-none text-left bg-gray-200 cursor-pointer"
                />
              </div>
            </div>
            {/* End Start Date */}

            {/* End Date */}
            <div className="w-full sm:w-3/12 flex flex-col gap-2">
              <p>非営業終了日</p>

              <div className="w-full flex justify-between items-center gap-2 bg-gray-200 p-2 rounded-[8px] border border-gray-500">
                <img src={CalendarIcon} alt="calendar-icon" className="w-5" />

                <DatePicker
                  selected={holidayEndDate}
                  onChange={(date) => setHolidayEndDate(date)}
                  dateFormat="yyyy/MM/dd"
                  locale={ja}
                  className="w-full outline-none text-left bg-gray-200 cursor-pointer"
                />
              </div>
            </div>
            {/* End End Date */}

            <button
              type="submit"
              className="w-max h-full flex justify-center items-center gap-2 px-4 py-2 mt-2 sm:mt-0 sm:ml-2 bg-primary text-white font-semibold rounded-[8px] text-xl"
            >
              <FaPlusCircle /> 追加
            </button>
          </form>
        </div>
      </div>
      {/* End Holiday Date Pick */}

      {/* Holiday Display */}
      <div className="flex gap-2 items-center px-2 pt-2">
        <label htmlFor="items_per_page pr-2">Show </label>
        <select
          name="items_per_page"
          id="items_per_page"
          onChange={(e) => setItemsPerPage(e.target.value)}
          className="bg-white border-[1px] border-black px-[2px] rounded-sm"
        >
          <option value="30">30</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        <p>entries</p>
      </div>

      {holidayLoading ? (
        <SpinnerComp />
      ) : (
        <div className="w-full relative overflow-x-auto px-2 mt-2">
          <table className="w-full table-auto min-w-[920px] overflow-x-auto">
            <thead className="text-black bg-gray-50 border-[1px] border-black">
              <tr className="py-12">
                {/* <th className='w-2/12 text-center text-md font-bold'></th> */}
                <th className="w-3/12 text-center text-md font-bold">
                  非営業日 開始日
                </th>
                <th className="w-3/12 text-center text-md font-bold">
                  非営業日 終了日
                </th>
                {/* <th className="w-3/12 text-center text-md font-bold">
                  メッセージを表示
                </th> */}
                <th className="w-3/12 text-center text-md font-bold">
                  アクション
                </th>
              </tr>
            </thead>
            <tbody className="text-black bg-gray-50 border-[1px] border-black">
              {currentItems?.map((holi, idx) => (
                <tr
                  key={holi.id}
                  className="odd:bg-gray-200 even:bg-white hover:bg-gray-300"
                >
                  <td className="w-3/12 text-center text-sm font-semibold">
                    {moment(holi.start_date, 'YYYY/MM/DD').format('YYYY-MM-DD')}
                  </td>
                  <td className="w-3/12 text-center text-sm font-semibold">
                    {moment(holi.end_date, 'YYYY/MM/DD').format('YYYY-MM-DD')}
                  </td>
                  <td className="w-3/12 text-center text-sm font-normal">
                    <div className="flex justify-center gap-[2px]">
                      <button
                        onClick={() => onEditClick(holi)}
                        className="bg-yellow-500 text-black px-2 py-[2px] my-2"
                      >
                        編集
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation()
                          onDeleteClick(holi)
                        }}
                        className="bg-red-700 text-white px-2 py-[2px] my-2"
                      >
                        削除
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* End Holiday Display */}

      {/* Holiday Pagination */}
      <ReactPaginate
        activeClassName={'flex justify-center items-center text-white '}
        breakLabel={'...'}
        containerClassName={
          'flex w-full max-w-[600px] justify-center items-center mx-auto bg-primary mt-4 text-lg text-gray-700'
        }
        disabledClassName={'text-gray-500'}
        marginPagesDisplayed={2}
        nextClassName={''}
        nextLabel={<FaAngleDoubleRight style={{ fontSize: 18, width: 150 }} />}
        onPageChange={handlePageClick}
        pageCount={pageCount || 0}
        pageClassName={'font-semibold px-2'}
        pageRangeDisplayed={2}
        previousClassName={''}
        previousLabel={
          <FaAngleDoubleLeft style={{ fontSize: 18, width: 150 }} />
        }
      />
      {/* End Holiday Pagination */}

      {/* Modal Edit */}
      <Modal
        isOpen={isModalEdit}
        onRequestClose={() => {
          setIsModalEdit(false)
          setEditTarget(null)
        }}
        style={customStylesEdit}
        contentLabel="edit long holiday"
      >
        <button
          className="float-right rounded-full text-black text-xl"
          onClick={() => {
            setIsModalEdit(false)
            setEditTarget(null)
          }}
        >
          <FaTimes />
        </button>
        <h2 className="text-left px-2 text-md sm:text-xl font-semibold mb-2">
          非営業日を設定してください。
        </h2>
        <p className="text-left px-2 text-md sm:text-xl font-semibold mb-8">
          {editTarget?.start_date} - {editTarget?.end_date}
        </p>
        {editTarget && holidayStartDateEdit && holidayEndDateEdit ? (
          <div className="w-12/12 flex justify-center gap-4">
            {/* Start Date */}
            <div className="w-5/12 flex flex-col gap-2">
              <p>非営業開始日</p>

              <div className="w-full flex justify-between items-center gap-2 bg-gray-200 p-2 rounded-[8px] border border-gray-500">
                <img src={CalendarIcon} alt="calendar-icon" className="w-5" />

                <DatePicker
                  selected={holidayStartDateEdit}
                  onChange={(date) => setHolidayStartDateEdit(date)}
                  dateFormat="yyyy/MM/dd"
                  locale={ja}
                  className="w-full outline-none text-left bg-gray-200 cursor-pointer"
                />
              </div>
            </div>
            {/* End Start Date */}

            {/* End Date */}
            <div className="w-5/12 flex flex-col gap-2">
              <p>非営業終了日</p>

              <div className="w-full flex justify-between items-center gap-2 bg-gray-200 p-2 rounded-[8px] border border-gray-500">
                <img src={CalendarIcon} alt="calendar-icon" className="w-5" />

                <DatePicker
                  selected={holidayEndDateEdit}
                  onChange={(date) => setHolidayEndDateEdit(date)}
                  dateFormat="yyyy/MM/dd"
                  locale={ja}
                  className="w-full outline-none text-left bg-gray-200 cursor-pointer"
                />
              </div>
            </div>
            {/* End End Date */}
          </div>
        ) : null}
        <form onSubmit={onEditSubmit} className="p-2 flex flex-col">
          <div className="flex justify-end gap-2">
            <button
              className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
              type="submit"
            >
              確定する
            </button>

            <button
              onClick={() => {
                setIsModalEdit(false)
                setEditTarget(null)
              }}
              className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
              type="button"
            >
              キャンセル
            </button>
          </div>
        </form>
      </Modal>
      {/* End Edit Delete */}

      {/* Modal Delete */}
      <Modal
        isOpen={isModalDelete}
        onRequestClose={() => {
          setIsModalDelete(false)
          setDeleteTarget(null)
        }}
        style={customStyles}
        contentLabel="delete long holiday"
      >
        <button
          className="float-right rounded-full text-black text-xl"
          onClick={() => {
            setIsModalDelete(false)
            setDeleteTarget(null)
          }}
        >
          <FaTimes />
        </button>
        <h2 className="text-left px-2 text-md sm:text-xl font-semibold mb-8">
          {deleteTarget?.start_date} から {deleteTarget?.end_date}
          までの非営業日を削除してもよろしいですか？
        </h2>
        <form onSubmit={onDeleteSubmit} className="p-2 flex flex-col">
          <div className="flex justify-end gap-2">
            <button
              className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
              type="submit"
            >
              確定する
            </button>

            <button
              onClick={() => {
                setIsModalDelete(false)
                setDeleteTarget(null)
              }}
              className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
              type="button"
            >
              キャンセル
            </button>
          </div>
        </form>
      </Modal>
      {/* End Modal Delete */}
    </div>
  )
}

const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: 1000,
  },
  content: {
    maxHeight: '80vh',
    width: '80%',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    position: 'relative',
    border: '1px solid black',
    background: '#fff',
  },
}

const customStylesEdit = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: 1000,
  },
  content: {
    minHeight: '420px',
    maxHeight: '80vh',
    width: '80%',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    position: 'relative',
    border: '1px solid black',
    background: '#fff',
  },
}

export default NonBusinessHoliday
